<template>
    <div class="row">
        <img class="rowIcon" v-if="iconName" :src="require('@/assets/' + iconName)">
        <span class="rowText">
            <div class="title" v-if="itemTitle" v-html="itemTitle"/>
            <div class="content" v-if="itemContent && itemContent.constructor == String" v-html="itemContent"/>
            <div class="content" v-if="itemContent && itemContent.constructor == Array">
                <ul><li v-for="(item, index) in itemContent" :key="index" v-html="item"/></ul>
            </div>
        </span>
    </div>
</template>

<script>
export default {
    name: 'IconListitem',
    props: ['iconName', 'itemTitle', 'itemContent'],
}
</script>

<style lang="scss" scoped>
.row {
    display: flex;
    align-items: start;
    margin-bottom: 1rem;
    &:last-child {
        margin-bottom: 0;
        .rowText {
            border: 0;
            padding: 0;
        }
    }
}
.rowIcon {
    width: 3rem;
    margin-right: 1.2rem;
    margin-top: 0.5rem;
    flex: 0 0 3rem;
}
.rowText {
    flex: 1 1 auto;
    border-bottom: 1px solid;
    padding-bottom: 1rem;
}

.title {
    font-size: 1.8rem;
    color: $colour__accent1;
    &:after {
        content: ':';
    }
}
.content {
    font-size: 1.6rem;
}

</style>

<style>
    .rowText ul {
        margin-left: 2rem;
    }
</style>
